import * as React from "react";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { Switch } from "../switch/Switch";
import { ScrollList } from "../../layout/scroll-list/index";
import styled from "styled-components";
const ScrollListItem = styled.div `
display: flex;
padding: 4px 8px;
align-items: center;
gap: 8px;
align-self: stretch;
border-radius: 4px;
background: var(--Neutral-White, #FEFEFE);
`;
const DragHandle = SortableHandle(() => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("mask", { id: "mask0_789_16574", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "20", height: "20" },
        React.createElement("rect", { width: "20", height: "20", fill: "#D9D9D9" })),
    React.createElement("g", { mask: "url(#mask0_789_16574)" },
        React.createElement("path", { d: "M10 18L6.5 14.5L7.5625 13.4375L9.25 15.125V10.75H4.875L6.5625 12.4375L5.5 13.5L2 10L5.5 6.5L6.5625 7.5625L4.875 9.25H9.25V4.875L7.5625 6.5625L6.5 5.5L10 2L13.5 5.5L12.4375 6.5625L10.75 4.875V9.25H15.125L13.4375 7.5625L14.5 6.5L18 10L14.5 13.5L13.4375 12.4375L15.125 10.75H10.75V15.125L12.4375 13.4375L13.5 14.5L10 18Z", fill: "#1C1B1F" })))));
const SortableItem = SortableElement((props) => (React.createElement(ScrollListItem, null,
    React.createElement(DragHandle, null),
    React.createElement("p", { style: { flex: 1, fontSize: 14, fontWeight: 500 } }, props.item.label),
    React.createElement(Switch, { id: `${props.item._id}-switch-list`, checked: props.item.enabled, onChange: (e) => props.parent.onCheck(props.itemIndex, props.item), variant: "black" }))));
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement(ScrollList, { height: props.height }, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, parent: props })))));
});
export class SwitchListSortablev2 extends React.Component {
    render() {
        const { height, items, onCheck, onSortEnd } = this.props;
        const itemsClean = items.map(item => {
            if (item._id === "config.distance") {
                if (this.props.units === "MILE") {
                    item.label = "Delivery Distance (mile)";
                }
                else {
                    item.label = "Delivery Distance (km)";
                }
            }
            return item;
        });
        return (React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, height: height, items: itemsClean, units: this.props.units, onCheck: onCheck, onSortEnd: onSortEnd }));
    }
}
//# sourceMappingURL=sortablev2.js.map